module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "pt1",
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('header', [_c('h1', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "aria-label": "27",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "id": "pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("PART 1")])])])]), _vm._v(" "), _c('h1', {
    staticClass: "PT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("THE WESTERN WINDS BLOW")])])])]), _vm._v(" "), _c('p', {
    staticClass: "PAGE-BREAK"
  }), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-No-Indent-potx1"
  }, [_c('span', {
    attrs: {
      "aria-label": "29",
      "id": "pg_29",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("There is a beauty to this mountain—Tzatzini to the xoconai, Fireach Speuer to the humans—that goes beyond its physical features, and one that remains constant whether looking below to the vast lake called Loch Beag, or now, the golden city of Otontotomi. For the real beauty of the mountain lies below its rocky spurs and lines of evergreen trees in caves filled with crystals and crystals filled with sparkling stones which carry within them magical energy beyond the strength of a warrior, beyond the power of an army.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("The xoconai claim this place as holy, as their own, the rightful domain and magic of Glorious Gold, their god Scathmizzane.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("The humans who lived here for centuries untold claim this place as holy, as their own, the rightful domain and magic of their god, Usgar.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("To the xoconai, the humans confuse their fake god with the demon Cizinfozza, which they called the fossa.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("I wonder, then, was this god, Usgar, truly the same as Cizinfozza? And so, a god or a demon?")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("Or are they the same thing, god and demon?")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("As I grow familiar with the similarities between the humans and the xoconai—the social and family structures, they way they go about their days in their respective villages and cities—I find that question coming to mind more often, and it is one that troubles me greatly. I was raised to favor a god, and to hate those who favored a different god. Or to pity those misguided others, at least, and to recognize that if we conquered them and showed them our god and our ways, they would be better off and would come to gratitude.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("Perhaps that is the case, perhaps not, or perhaps it fluctuates back and forth as the respective societies change and evolve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("But none of that really has anything to do with the gods, or demons, or whatever they are.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    attrs: {
      "aria-label": "30",
      "id": "pg_30",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("The humans of this conquered land surely do not appreciate the coming of the xoconai at this time. Hundreds were killed, thousands taken as prisoner, to now work hard under the merciless eyes of the xoconai augurs. What love can any parent, xoconai or human, hold towards an invading army that stole a child and destroyed a home? Even if the xoconai show this conquered people a better way of life, that sting is profound and lasting.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("Will the eventual outcome dull the desire for vengeance? How many generations will need to pass, I wonder, before there can be any true mending of the relationship?")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("Or will that not matter to the xoconai? Perhaps the augurs will demand that the humans be wholly eradicated, worked to death in slavery or sacrificed to Glorious Gold. Perhaps in the end, Tonoloya, the nation of the xoconai, will stretch from sea to sea as Scathmizzane demands, and within that vast nation, humans will be erased, first chased to the edges of civilization, then hunted down and murdered.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("Then will Tonoloya know peace from the humans.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("But I see these humans, their ways, their familial love, their hopes, and know they are akin to the xoconai in all of these things, person to person. And in that truth, how is Cizinfozza an evil and monstrous demon, but Scathmizzane a wonderful god, Glorious Gold?")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("I have come to see, to my hope and my sadness, that if the distinction is merely that this god or that god is my god, and that I am little different from my enemy who serves a different god, and if our gods demand that we two peoples do war, then perhaps we are both better served with no god.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("To everything I learned in my youth, this is blasphemy. And were I to speak it aloud, my end would be certain and painful and the memory of me would be erased except in whispers among those few who might agree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("To deny it in my private ruminations, however, is to kill the truth of myself, of who I am and what I believe and hold dear, and that truth is more important to me than the body that holds it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('i', [_vm._v("I sign this your student, forever in your debt,")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "Letter-Ext-Closing-lcl"
  }, [_vm._v("—Ag’ardu An’grian")]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Signature-lsig"
  }, [_c('i', [_vm._v("Sunrise Face")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 75
// module chunks = 0